import apiClient from "../../../helpers/apiClient";

const api = apiClient();

export const getTenantTopics = async (tenantId) => {
  if (!tenantId) {
    throw new Error("tenantId es requerido");
  }
  return api.get(`/api/tenants/${tenantId}/topics`);
};

export const addTenantTopic = async (tenantId, topicId) => {
  if (!tenantId) {
    throw new Error("tenantId es requerido");
  }
  if (!topicId) {
    throw new Error("topicId es requerido");
  }
  return api.post(`/api/tenants/${tenantId}/topics`, { topicId });
};
